module.exports = __webpack_public_path__ + "img/site-vitrine-mobile.2ce0df49.jpg";